<template>
    <div class="entities-search-wrap">
        <or-search-box
            v-model="localSearchText"
            class="search"
            :placeholder-text="$t('generic.search')"
        />

        <or-select
            v-model="localCheckedEntityTypes"
            :options="entityTypesOptions"
            multiple
            class="entities-types-select"
            :placeholder="$t('model.nlu-model.sidebar.entities.list.entitiessearch.entityType')"
        >
            <template slot-scope="props" slot="option">
                <div class="search-select--option">
                    <or-checkbox class="option--checkbox" :value="props.selected" />
                    <div class="option--image">{{props.option.image}}</div>
                    <div class="option--label">{{props.option.label}}</div>
                </div>
            </template>
        </or-select>
    </div>
</template>

<script>
import { entityTypesOptions, getEntityTypeLabel } from '../entity-types'
export default {
  data () {
    return {
      entityTypesOptions: entityTypesOptions.map(entityType => ({
        ...entityType,
        image: getEntityTypeLabel(entityType.value)
      }))
    }
  },

  props: {
    searchText: String,
    checkedEntityTypes: Array
  },

  computed: {
    localSearchText: {
      get () {
        return this.searchText
      },
      set (value) {
        this.$emit('update:searchText', value)
      }
    },

    localCheckedEntityTypes: {
      get () {
        return this.checkedEntityTypes
      },
      set (value) {
        this.$emit('update:checkedEntityTypes', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .entities-search-wrap {
        display: flex;
        margin-bottom: $sp-3;

        .search {
            margin-right: $sp-2;
            height: 36px;

            .searchbox-wrapper .search-icon .ui-icon {
                font-size: 16px;
            }
        }

        .ui-select {
            margin: 0;
        }

        .entities-types-select {
            min-width: 136px;
            width: 150px;
        }
    }
</style>

<style lang="scss">
    .entities-search-wrap > .search {
        .ui-icon {
            font-size: 16px;
        }
    }

    .search-select--option {
        margin: 2px 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .option--checkbox {
            margin: 0;
            pointer-events: none;
        }

        .option--image {
            width: 20px;
            height: 16px;
            margin: 0 8px;
            color: rgb(198, 198, 198);
            font-size: 14px;
            font-weight: 600;
            letter-spacing: -0.45px;
            text-align: center;
        }
        .option--label {
            color: rgb(30, 35, 43);
            font-size: 14px;
            font-weight: normal;
        }
    }
</style>
